<script>
  import ProductLineList from "@retailer/svelte/ListBuilder/Components/ProductLineSearch/ProductLineList.svelte";
  import SearchInput from "@retailer/svelte/ListBuilder/Components/ProductLineSearch/SearchInput.svelte";
  export let results;
  export let isVisible;
  export let list;
  export let query;
  export let onSearch;
  export let onChooseSize;
  export let onAddToListChooseSizeLater;
  export let onRemoveProductLinePlaceholder;

  function getCurrentScreen() {
    if (query == null) {
      return "Empty";
    }
    if (query != null && results == null) {
      return "SearchAPICallHappening";
    }
    if (results && results.length === 0) {
      return "SearchCompleteWithNoResults";
    }
    return "SearchCompleteWithResults";
  }
  $: currentScreen = getCurrentScreen();
  $: {
    query = query;
    results = results;
    currentScreen = getCurrentScreen();
  }
</script>

<div id="product-line-search">
  <header>
    <SearchInput {query} {onSearch} {isVisible} />
  </header>
  {#if currentScreen === "Empty"}
    <div />
  {:else if currentScreen === "SearchAPICallHappening"}
    <div
      class="display-block full-width align-center margin-top--medium margin--medium--md secondary-subheader--regular secondary-headline--regular--md"
    >
      Searching...
    </div>
  {:else if currentScreen === "SearchCompleteWithNoResults"}
    <div
      class="display-block full-width align-center margin-top--medium margin--medium--md secondary-subheader--regular secondary-headline--regular--md"
    >
      No results found for &quot;{query}&quot;
    </div>
  {:else if currentScreen === "SearchCompleteWithResults"}
    <ProductLineList
      {list}
      {results}
      {onChooseSize}
      {onAddToListChooseSizeLater}
      {onRemoveProductLinePlaceholder}
    />
  {/if}
</div>
